'use strict';

var SpinnerDirective = require('./directives/SpinnerDirective');

var dialog = angular.module('app.dialogs', []);

dialog.controller('AppDialogsController', require('./AppDialogsController'))
dialog.directive('appDialogs', require('./AppDialogsDirective'))
dialog.directive('globalSpinner', SpinnerDirective)

// ## Flux Actions and Store
dialog.factory('AppDialogsActions', require('./AppDialogsActions'))
dialog.factory('AppDialogsStore', require('./AppDialogsStore'))

//Bind store to actions through init method
dialog.run(['AppDialogsStore', function (AppDialogsStore) {
  AppDialogsStore.init();
}])



// WEBPACK FOOTER //
// ./src/app/dialogs/index.js